import React from 'react';
import AddSparkStepButton from 'components/CreateSpark/AddSparkStepButton';
import { Box } from '@mui/material';
import { NODE_MIN_WIDTH } from '../../hooks';
import { SuccessStatusIcon } from 'components/SVG';
import { useSparkBuilderStore } from 'stores';
type CustomSparkButtonEdgeProps = {
  labelX: number;
  labelY: number;
  isPreview?: boolean | undefined;
};
function CustomSparkButtonEdge({
  labelX,
  labelY,
  isPreview = true,
}: CustomSparkButtonEdgeProps) {
  const openAddDialog = useSparkBuilderStore(
    (store) => store.canvasActions.openAddDialog
  );
  return (
    <Box
      sx={{
        position: 'absolute',
        transform: `translate(-50%, -50%) translate(${labelX}px,${labelY}px)`,
        fontSize: 12,
        pointerEvents: 'all',
      }}
      className='nopan'
    >
      {isPreview ? (
        <Box
          sx={{
            border: (theme) => `3px dashed ${theme.palette.primary.main}`,
            bgcolor: (theme) => theme.palette.primary.light,
            minHeight: '3rem',
            width: `${NODE_MIN_WIDTH - 120}px`,
            borderRadius: '10px',
            padding: 3,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            marginLeft: '25px',
          }}
          className='spark_preview_node'
        >
          <Box sx={{ marginLeft: '-25px' }}>
            <SuccessStatusIcon fill='#6267AC' />
          </Box>
        </Box>
      ) : (
        <AddSparkStepButton onClick={openAddDialog} />
      )}
    </Box>
  );
}

export default CustomSparkButtonEdge;
